import React, { useCallback, useContext, useEffect, useState } from "react";
import Permiso from "../../router/Permiso";
import { Edit, Plus, View } from "lucide-react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ReportesService } from "../../services/ReportesService";


const ReporteConfigAdmin = ({ refreshTrigger = 0 }) => {
    const { token } = useContext(AuthContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [reportes, setReportes] = useState([]);
    const [buscarProducto, setBuscarProducto] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);

    const handleOpenNewConfiguration = () => {
        navigate("/admin/reporteconfig/registrar");
    };

    const irAEditar = (id) => {
        navigate(`/admin/reporteconfig/edit/${id}`);
    };

    const fetchProductos = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await ReportesService.getConfigurationList({
                token,
                pagina: currentPage,
                pageSize: 20,
                nombre: buscarProducto,
            });

            setReportes(res.reportes);
            setTotalPages(res.totalPaginas);
            setTotalRegistros(res.totalRegistros);
        } catch (err) {
            console.error("Error al cargar los reportes:", err);
            setError("Error al cargar los reportes");
        } finally {
            setLoading(false);
        }
    }, [token, currentPage, buscarProducto]);;

    useEffect(() => {
        fetchProductos();
    }, [fetchProductos]);


    const verDetalle = (reporte) => {
        navigate(`/admin/reporteconfig/${reporte.id}`, {
            state: { reporte: reporte }
        });
    };

    const TIPO_REPORTE_STYLES = {
        listado: { label: 'Tabla', icon: '📋', color: '#e3f2fd', textColor: '#1976d2' },
        barra: { label: 'Gráfico Barras', icon: '📊', color: '#f3e5f5', textColor: '#7b1fa2' },
        linea: { label: 'Gráfico Líneas', icon: '📈', color: '#e8f5e9', textColor: '#388e3c' },
        pie: { label: 'Gráfico Pastel', icon: '⭕', color: '#fff3e0', textColor: '#f57c00' },
    };

    return (
        <div className="productos-admin-content">
            <div className="productos-admin-header">
                <div className="productos-admin-header-row">
                    <div>
                        <div className="productos-admin-title">Configuración</div>
                        <div className="productos-admin-subtitle">
                            Listado de reportes configurados
                        </div>
                    </div>
                    <div className="usuarios-admin-actions">
                        <Permiso permiso="add_report_config">
                            <button onClick={handleOpenNewConfiguration} className="btn-nuevo">
                                <Plus size={18} style={{ marginRight: "6px" }} /> Nueva configuración
                            </button>
                        </Permiso>

                    </div>
                </div>

            </div>
            <div className="productos-admin-tab-content">
                <div className="usuarios-filtros">
                    <div className="filtro-item">
                        <label htmlFor="buscar">Buscar:</label>
                        <input
                            type="text"
                            value={buscarProducto}
                            onChange={(e) => setBuscarProducto(e.target.value)}
                            placeholder="Ingrese nombre del reporte"
                            className=""
                        />
                    </div>
                    <div className="filtro-grupo">
                        <button onClick={fetchProductos} className="btn-buscar">
                            Buscar
                        </button>
                    </div>
                    <div className="filtro-grupo">
                        <button
                            onClick={() => {
                                setBuscarProducto("");
                            }}
                            className="btn-limpiar-filtros"
                        >
                            Limpiar Filtros
                        </button>
                    </div>
                </div>
                {error && <div className="error-message">{error}</div>}

                {loading ? (
                    <div className="loading">
                        <div className="loading-spinner"></div>
                        <p>Cargando reportes configurados...</p>
                    </div>
                ) : (
                    <>
                        <div className="productos-table-wrapper">
                            <table className="productos-table">
                                <thead>
                                    <tr>
                                        <th>Tipo de Reporte</th>
                                        <th>Nombre del Reporte</th>
                                        <th>Fecha de Creación</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportes.length === 0 ? (
                                        <tr>
                                            <td colSpan="4" className="no-data">
                                                <div className="no-data-content">
                                                    <p>No hay reportes registrados</p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        reportes.map((reporte) => {
                                            const estilo = TIPO_REPORTE_STYLES[reporte.tipo_reporte] || { label: reporte.tipo_reporte, icon: '📄', bg: '#eee', color: '#333' };

                                            return (
                                                <tr key={reporte.id} className="producto-row">
                                                    <td>

                                                        {estilo.label}
                                                    </td>

                                                    <td style={{ fontWeight: '500', color: '#2c3e50' }}>
                                                        {reporte.nombre_reporte}
                                                    </td>


                                                    <td style={{ color: '#7f8c8d' }}>
                                                        {new Date(reporte.created_at).toLocaleDateString('es-ES', {
                                                            year: 'numeric',
                                                            month: 'short',
                                                            day: 'numeric'
                                                        })}
                                                    </td>


                                                    <td className="producto-acciones">
                                                        <Permiso permiso="edit_report_config">
                                                            <span
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => verDetalle(reporte)}

                                                            >
                                                                <View size={20} />
                                                            </span>
                                                        </Permiso>
                                                        <Permiso permiso="view_report_config">
                                                            <span
                                                                style={{ cursor: "pointer", color: "#007bff" }}
                                                                onClick={() => irAEditar(reporte.id)}
                                                                title="Editar configuración"
                                                            >
                                                                <Edit size={20} />
                                                            </span>
                                                        </Permiso>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
                            {" "}
                            Total de registros: {totalRegistros}{" "}
                        </span>
                        <div className="pagination">
                            <button
                                onClick={() => setCurrentPage(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Anterior
                            </button>
                            <span>
                                Página {currentPage} de {totalPages}
                            </span>

                            <button
                                onClick={() => setCurrentPage(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Siguiente
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};


export default ReporteConfigAdmin;